export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Food Services.c8b3ccbb.PNG";